<!-- Page content -->
<div class="container-fluid my-5">
  <!-- Table -->
  <div class="row" *ngIf="!loading">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-12">
          <h2>Mon profil</h2>
        </div>
      </div>
      <!-- personnal data -->
      <div class="row" [ngClass]="{'mt-4':show_reset_password,'mt-7':!show_reset_password}">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0" *ngIf="!show_reset_password">
          <div class="card bg-secondary card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="javascript:void(0)">
                    <img [src]="image?image:currentUser.profile.thumbnail" class="rounded-circle">
                  </a>
                </div>
              </div>
            </div>

            <div class="card-body pt-7">
              <div class="row">
                <div class="col mb-3 text-center">
                  <a href="javascript:void(0)" (click)='inputFile.click()'>Changer ma photo</a>
                  <input hidden (change)="uploadFile($event)" accept="image/gif, image/jpeg, image/png" type="file"
                    #inputFile>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  {{currentUser.profile.title}}<span class="font-weight-light">,
                    {{currentUser.profile.full_name}}</span>
                </h3>
                <h3>
                  <span class="font-weight-light">
                    {{currentUser.profile.email}}</span>
                </h3>
                <div class="h5 font-weight-300" *ngIf="currentUser.profile.address">
                  <i class="ni location_pin mr-2"></i>{{currentUser.profile.city}}, {{currentUser.profile.country}}
                </div>
                <button (click)="setupStripeAccount()" class="btn btn-studiomap mt-3 w-100" type="button"
                  *ngIf="currentUser && currentUser.switch_account == 'manager_studio' && currentUser?.stripe?.payouts_enabled != true">
                  Verifié votre compte
                </button>

                <h4 class="text-center text-success mt-3"
                  *ngIf="currentUser && currentUser.switch_account == 'manager_studio' && currentUser?.stripe?.payouts_enabled == true">
                  <i class="fa fa-check"></i> Compte vérifié</h4>

              </div>
            </div>
          </div>
        </div>
        <div class="order-xl-1" [ngClass]="{'col-12':show_reset_password,'col-xl-8':!show_reset_password}">
          <div class="card bg-secondary shadow">
            <div class="card-body">
              <form *ngIf="!show_reset_password" [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h6 class="heading-small text-muted mb-4">Mes informations</h6>
                  </div>
                  <div class="col-4 text-right">
                    <button *ngIf="!show_reset_password" class="btn btn-studiomap" (click)="onSubmit()" type="button"><i
                        class="fa fa-edit" style="margin: 0 !important;"></i>
                      <span class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Modifier</span>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-first-name">Nom et prénom</label>
                      <input [ngClass]="{'border-error':formControl.full_name.errors && submitted}"
                        formControlName="full_name" type="text" id="input-first-name"
                        class="form-control form-control-alternative" placeholder="First name" value="Lucky">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-last-name">titre</label>
                      <div class="form-control form-control-alternative" style="height: auto;">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input [ngClass]="{'border-error':formControl.title.errors && submitted}"
                            formControlName="title" type="radio" id="monsieur" value="monsieur"
                            class="custom-control-input">
                          <label class="custom-control-label" for="monsieur">Monsieur</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input [ngClass]="{'border-error':formControl.title.errors && submitted}"
                            formControlName="title" type="radio" id="madame" value="madame"
                            class="custom-control-input">
                          <label class="custom-control-label" for="madame">Madame</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-phone">Téléphone</label>
                      <input *ngIf="currentUser.provider == 'phone'"
                        [ngClass]="{'border-error':formControl.phone.errors && submitted}" formControlName="phone"
                        type="text" id="phone" class="form-control form-control-alternative" placeholder="Téléphone"
                        readonly>
                      <input *ngIf="currentUser.provider != 'phone'"
                        [ngClass]="{'border-error':formControl.phone.errors && submitted}" formControlName="phone"
                        type="text" id="phone" class="form-control form-control-alternative" placeholder="Téléphone">
                    </div>
                  </div>
                  <div class="col-lg-6" *ngIf="currentUser.switch_account == 'manager_studio'">
                    <div class="form-group">
                      <label class="form-control-label" for="input-phone">IBAN</label>
                      <input [ngClass]="{'border-error':formControl.iban.errors && submitted}" formControlName="iban"
                        type="text" class="form-control form-control-alternative" placeholder="IBAN">
                    </div>
                  </div>
                </div>

                <hr class="my-4" />
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">Informations de facturation</h6>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="form-control-label" for="input-address">Adresse</label>
                      <input [ngClass]="{'border-danger':formControl.address.errors && submitted}"
                        formControlName="address" #placesRef ngx-google-places-autocomplete
                        placeholder="veuillez sélectionner une adresse" (onAddressChange)="handleAddressChange($event)"
                        type="text" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="form-control-label" for="input-city">Ville</label>
                      <input type="text" id="input-city" class="form-control form-control-alternative"
                        placeholder="Ville" [ngClass]="{'border-error':formControl.city.errors && submitted}"
                        formControlName="city">
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="form-control-label" for="input-country">Pays</label>
                      <input type="text" id="input-country" class="form-control form-control-alternative"
                        placeholder="Pays" [ngClass]="{'border-error':formControl.country.errors && submitted}"
                        formControlName="country">
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="form-control-label" for="input-country">Code postal</label>
                      <input type="number" id="input-postal-code" class="form-control form-control-alternative"
                        placeholder="Code postal"
                        [ngClass]="{'border-error':formControl.postal_code.errors && submitted}"
                        formControlName="postal_code">
                    </div>
                  </div>
                </div>
              </form>

              <hr *ngIf="!show_reset_password" class="my-4" />

              <form [formGroup]="formResetPassword" (ngSubmit)="onReset()">

                <div class="row align-items-center">
                  <div class="col-8">
                    <h6 class="heading-small text-muted mb-4">Réinitialisation de mot de passe</h6>
                  </div>
                  <div class="col-4 text-right">

                    <button class="btn btn-studiomap" type="submit"><i class="fa fa-edit"
                        style="margin: 0 !important;"></i>
                      <span class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Réinitialiser</span>
                    </button>
                  </div>
                </div>


                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="mot de passe">Mot de passe</label>
                      <input [ngClass]="{'border-error':resetPassword.password.errors && submittedResetPassword}"
                        formControlName="password" type="password" id="mot de passe"
                        class="form-control form-control-alternative" placeholder="Mot de passe">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="Confirmation">Confirmation de mot de passe</label>
                      <input
                        [ngClass]="{'border-error':resetPassword.passwordConfirmation.errors && submittedResetPassword}"
                        formControlName="passwordConfirmation" type="password" id="Confirmation"
                        class="form-control form-control-alternative" placeholder="Confirmation de mot de passe">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>